import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Redirect } from 'react-router-dom';
import renderHTML from 'react-render-html';
import { Fade } from 'react-reveal';
import { Actions } from '../../../flux';
import { images, texts, relacionamentos } from '../../../settings';
import { DelayLink, SliderText } from '../../../components';

import '../Iniciativas.scss';
import './GestaoDeFornecedores.scss';

class GestaoDeFornecedores extends Component {
  constructor(props) {
		super(props);

		this.state = {
			selected: 'mulher',
			mobile: (window.innerWidth < 768) ? true : false
		}

		this.contentText = React.createRef();
  }

  scrollTop = () => {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  }

  componentDidMount = () => {
    Actions.headerIntern();
		this.scrollTop();

		// if (this.state.mobile == true) {
		// 	this.mobileNav();
		// }
	}
	
	mobileNav = () => {
	}

	changeItem = () => {
		const { selected } = this.state
		this.setState({
			selected: (selected == 'mulher') ? 'homem' : 'mulher'
		});
	}

  render = () => {
		const { selected } = this.state
    return (
      <div className="views" ref={this.contentText}>
				<Helmet>
					<title>Gestão de Fornecedores - Iniciativas - {texts.title}</title>
				</Helmet>
				
				<div className="iniciativas-home treinamentos-home page-gradient page-gradient--yellow bg-gray bg-programa-de-supervisao" ref="treinamentos-home">

					<section className="iniciativas-area page--yellow">
						<div className="container container--large">
							<div className="row">
								<div className="col-12">
									<Fade bottom>
										<div className={`card card--page-body card--light-blue`}>
											<div className="card__content">
												<div className="card__content__header after-header-programa-de-supervisao">
													<DelayLink to={`/estrategias/dentro-de-casa`} className="button button--aylen button--gray-500 button--border-medium button--size-m button--round-l button--text-thick">
														Voltar
													</DelayLink>
													<h1 className="title title--gray titulo-programa-de-supervisao">
                            Gestão de fornecedores assegura qualificação
														<span className="gri-gestao-de-fornecedores">
                              GRI <b>102-9, 102-10</b>
														</span>
													</h1>
												</div>
												<div className="conteudo-gestao-fornecedores">
                          <div className="conteudo-imagem-gestao-fornecedores">
													  <img src={images.gestao_de_fornecedores.pc_gestao_de_fornecedores} alt="Home"/>
                          </div>
                          <div className="conteudo-imagem-gestao-fornecedores-animada">
                            <img src={images.gestao_de_fornecedores.computador} alt="Computador"/>
                            <img src={images.gestao_de_fornecedores.cadeado} alt="Cadeado"/>
                          </div>
													<p>
                            Em 2020, realizamos um trabalho de qualificação da cadeia de suprimentos por meio de um processo de revisão do cadastro de fornecedores visando selecionar aqueles que atendem nossas demandas recorrentes, critérios de qualidade e práticas de compliance.
                            <br/><br/>
                            Iniciamos o trabalho com 11.894 fornecedores cadastrados e o primeiro passo foi realizar análises fiscal, financeira e contábil de todos. A partir daí, bloqueamos todos que apresentaram alguma não-conformidade, o que representou um total de 5.486 fornecedores, ou 46% da base inicial.
                            <br/><br/>
                            O segundo passo foi excluir, entre os 6.408 restantes, aqueles com os quais não havíamos mantido nenhuma relação comercial nos últimos dois anos. A ideia era ter uma base mais enxuta para assegurar eficiência nos processos de compras e diminuir os riscos relacionados à LGPD (Lei Geral de Proteção de Dados). Com isso, 5.487 foram desconsiderados e restou uma base de 921 fornecedores que passaram por uma avaliação mais abrangente de acordo com o tamanho e relevância de cada um deles em nossa cadeia.
                            <br/><br/>
                            Após esta última análise, passamos a contar com 591 fornecedores cadastrados e habilitados para nos atender de acordo com as melhores práticas de mercado e também em conformidade com nossa Política de Contratação de Terceiros, revisada em 2020.
                            <br/><br/>
                            A atualização desta política trouxe uma nova lista de documentos solicitados, mais completa e adequada à LGPD, além de incluir cláusulas que tratam da análise, validação e monitoramento da situação fiscal e financeira da empresa contratada.
                          </p>
												</div>
											</div>
										</div>
									</Fade>
								</div>
							</div>
						</div>
					</section>
				</div>
      </div>
    );
  }
}

export { GestaoDeFornecedores };
